import React from 'react'
import AdminContract from '../../../../components/customer/adminContract/AdminContract'

const AEACustomerAdminContract = () => {
    return <AdminContract />
}

export default AEACustomerAdminContract
